import SalesOrderList from './SalesOrder/SalesOrderList';
import RestaurantSalesPage from './RestaurantSalesPage';

function getCachedTenantType() {
  try {
    const cached = localStorage.getItem('cachedTenant');
    return cached ? JSON.parse(cached).tenantType : null;
  } catch {
    return null;
  }
}

export default function SalesOrderRoute() {
  const tenantType = getCachedTenantType();

  if (tenantType === 'restaurant') {
    return <RestaurantSalesPage />;
  }

  return <SalesOrderList />;
}
